// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";
/* ==================================================================================
 * 메인 > 다운로드 (DownloadPortalMain.tsx)
 *   - #wrap.page-market.download 에서만 적용 (MainPortalLayout getClassName)
 *   - PC 1920 기준 피그마 : 본문 972px, 카드 84px, 버튼 108x40
 *   - 1278px 이하 : 좌우 20px 여백 / 732px 이하 : 모바일 (제목 좌측, 탭 가로 스크롤, 버튼 아래)
 * ================================================================================== */

#wrap.page-market.download > .container {
  background: linear-gradient(180deg, #f7f8fa 0, rgba(247, 248, 250, 0) 360px);
}

#wrap.page-market.download .download-page,
#wrap.page-market.download .download-page * {
  box-sizing: border-box;
}

/* 공통 .container 가 display:flex 라 섹션이 내용 폭으로 줄어드므로 전체 폭을 차지하게 한다. */
#wrap.page-market.download .download-page {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  padding: 124px 20px 160px;
}

#wrap.page-market.download .download-page__title {
  font-size: 44px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: -1px;
  color: #2a2c2f;
  text-align: center;
}

#wrap.page-market.download .download-page__body {
  max-width: 972px;
  margin: 56px auto 0;
}

/* 탭 */
#wrap.page-market.download .download-tab {
  display: flex;
  border-bottom: 1px solid #dde2e9;
  overflow-x: auto;
  scrollbar-width: none;
}
#wrap.page-market.download .download-tab::-webkit-scrollbar {
  display: none;
}
#wrap.page-market.download .download-tab li {
  flex: none;
}
#wrap.page-market.download .download-tab li a {
  display: block;
  padding: 0 24px;
  height: 56px;
  line-height: 54px;
  font-size: 20px;
  color: #6b7280;
  white-space: nowrap;
  border-bottom: 3px solid transparent;
  margin-bottom: -1px;
}
#wrap.page-market.download .download-tab li a .count {
  margin-left: 8px;
  color: #9aa3b2;
}
#wrap.page-market.download .download-tab li.on a {
  color: #2a2c2f;
  font-weight: 500;
  border-bottom-color: #0a78ff;
}
#wrap.page-market.download .download-tab li.on a .count {
  color: #0a78ff;
  font-weight: 400;
}

/* 목록 */
#wrap.page-market.download .download-list {
  margin-top: 40px;
}
#wrap.page-market.download .download-item {
  display: flex;
  align-items: center;
  min-height: 84px;
  padding: 18px 24px 18px 30px;
  border: 1px solid #dde2e9;
  border-radius: 4px;
  background: #fff;
  transition: box-shadow 0.15s;
}
#wrap.page-market.download .download-item + .download-item {
  margin-top: 8px;
}
#wrap.page-market.download .download-item__no {
  flex: none;
  width: 58px;
  font-size: 18px;
  color: #6b7a90;
}
#wrap.page-market.download .download-item__title {
  flex: 1;
  min-width: 0;
  font-size: 18px;
  color: #2a2c2f;
  word-break: keep-all;
  overflow-wrap: anywhere;
}
#wrap.page-market.download .download-item__btn {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 108px;
  height: 40px;
  margin-left: 24px;
  border: 1px solid #dde2e9;
  border-radius: 2px;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #1c2f55;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s;
}
/* HOVER / PRESS : 카드 그림자 + 버튼 파란색 */
#wrap.page-market.download .download-item:hover,
#wrap.page-market.download .download-item:active {
  box-shadow: 0 4px 12px rgba(42, 44, 47, 0.1);
}
#wrap.page-market.download .download-item:hover .download-item__btn,
#wrap.page-market.download .download-item:active .download-item__btn {
  background: #0a78ff;
  border-color: #0a78ff;
  color: #fff;
}
#wrap.page-market.download .download-item__btn:focus-visible {
  outline: 2px solid #0a78ff;
  outline-offset: 2px;
}

#wrap.page-market.download .download-empty {
  padding: 120px 0;
  text-align: center;
  font-size: 16px;
  color: #9aa3b2;
}

/* 페이징 1 / N */
#wrap.page-market.download .download-paging {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  margin-top: 48px;
}
#wrap.page-market.download .download-paging .num {
  min-width: 40px;
  text-align: center;
  font-size: 14px;
  color: #2a2c2f;
}
#wrap.page-market.download .download-paging button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: 0;
  color: #2a2c2f;
  cursor: pointer;
}
#wrap.page-market.download .download-paging button:disabled {
  color: #c5cbd5;
  cursor: default;
}

/* 태블릿 */
@media screen and (max-width: 1278px) {
  #wrap.page-market.download .download-page {
    padding: 100px 20px 120px;
  }
}

/* 모바일 */
@media screen and (max-width: 732px) {
  #wrap.page-market.download .download-page {
    padding: 48px 0 100px;
  }
  #wrap.page-market.download .download-page__title {
    padding: 0 20px;
    font-size: 32px;
    text-align: left;
  }
  #wrap.page-market.download .download-page__body {
    margin-top: 40px;
  }
  #wrap.page-market.download .download-tab li a {
    padding: 0 20px;
    height: 48px;
    line-height: 46px;
    font-size: 16px;
  }
  #wrap.page-market.download .download-list {
    margin: 32px 16px 0;
  }
  #wrap.page-market.download .download-item {
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 20px 16px 16px 22px;
  }
  #wrap.page-market.download .download-item__no {
    width: 34px;
    font-size: 15px;
    line-height: 24px;
  }
  #wrap.page-market.download .download-item__title {
    flex-basis: calc(100% - 34px);
    font-size: 15px;
    line-height: 24px;
  }
  #wrap.page-market.download .download-item__btn {
    margin: 16px 0 0 auto;
  }
  #wrap.page-market.download .download-paging {
    margin-top: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./static/css/download.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;uFAKuF;;AAEvF;EACE,4EAA4E;AAC9E;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,MAAM;AACN;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,OAAO;AACP;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,cAAc;AAChB;AACA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mEAAmE;AACrE;AACA,oCAAoC;AACpC;;EAEE,4CAA4C;AAC9C;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,QAAQ;AACR;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,QAAQ;AACR;EACE;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@charset \"utf-8\";\n/* ==================================================================================\n * 메인 > 다운로드 (DownloadPortalMain.tsx)\n *   - #wrap.page-market.download 에서만 적용 (MainPortalLayout getClassName)\n *   - PC 1920 기준 피그마 : 본문 972px, 카드 84px, 버튼 108x40\n *   - 1278px 이하 : 좌우 20px 여백 / 732px 이하 : 모바일 (제목 좌측, 탭 가로 스크롤, 버튼 아래)\n * ================================================================================== */\n\n#wrap.page-market.download > .container {\n  background: linear-gradient(180deg, #f7f8fa 0, rgba(247, 248, 250, 0) 360px);\n}\n\n#wrap.page-market.download .download-page,\n#wrap.page-market.download .download-page * {\n  box-sizing: border-box;\n}\n\n/* 공통 .container 가 display:flex 라 섹션이 내용 폭으로 줄어드므로 전체 폭을 차지하게 한다. */\n#wrap.page-market.download .download-page {\n  flex: 1 1 auto;\n  width: 100%;\n  min-width: 0;\n  padding: 124px 20px 160px;\n}\n\n#wrap.page-market.download .download-page__title {\n  font-size: 44px;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: -1px;\n  color: #2a2c2f;\n  text-align: center;\n}\n\n#wrap.page-market.download .download-page__body {\n  max-width: 972px;\n  margin: 56px auto 0;\n}\n\n/* 탭 */\n#wrap.page-market.download .download-tab {\n  display: flex;\n  border-bottom: 1px solid #dde2e9;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n#wrap.page-market.download .download-tab::-webkit-scrollbar {\n  display: none;\n}\n#wrap.page-market.download .download-tab li {\n  flex: none;\n}\n#wrap.page-market.download .download-tab li a {\n  display: block;\n  padding: 0 24px;\n  height: 56px;\n  line-height: 54px;\n  font-size: 20px;\n  color: #6b7280;\n  white-space: nowrap;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -1px;\n}\n#wrap.page-market.download .download-tab li a .count {\n  margin-left: 8px;\n  color: #9aa3b2;\n}\n#wrap.page-market.download .download-tab li.on a {\n  color: #2a2c2f;\n  font-weight: 500;\n  border-bottom-color: #0a78ff;\n}\n#wrap.page-market.download .download-tab li.on a .count {\n  color: #0a78ff;\n  font-weight: 400;\n}\n\n/* 목록 */\n#wrap.page-market.download .download-list {\n  margin-top: 40px;\n}\n#wrap.page-market.download .download-item {\n  display: flex;\n  align-items: center;\n  min-height: 84px;\n  padding: 18px 24px 18px 30px;\n  border: 1px solid #dde2e9;\n  border-radius: 4px;\n  background: #fff;\n  transition: box-shadow 0.15s;\n}\n#wrap.page-market.download .download-item + .download-item {\n  margin-top: 8px;\n}\n#wrap.page-market.download .download-item__no {\n  flex: none;\n  width: 58px;\n  font-size: 18px;\n  color: #6b7a90;\n}\n#wrap.page-market.download .download-item__title {\n  flex: 1;\n  min-width: 0;\n  font-size: 18px;\n  color: #2a2c2f;\n  word-break: keep-all;\n  overflow-wrap: anywhere;\n}\n#wrap.page-market.download .download-item__btn {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 108px;\n  height: 40px;\n  margin-left: 24px;\n  border: 1px solid #dde2e9;\n  border-radius: 2px;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1c2f55;\n  cursor: pointer;\n  transition: background-color 0.15s, color 0.15s, border-color 0.15s;\n}\n/* HOVER / PRESS : 카드 그림자 + 버튼 파란색 */\n#wrap.page-market.download .download-item:hover,\n#wrap.page-market.download .download-item:active {\n  box-shadow: 0 4px 12px rgba(42, 44, 47, 0.1);\n}\n#wrap.page-market.download .download-item:hover .download-item__btn,\n#wrap.page-market.download .download-item:active .download-item__btn {\n  background: #0a78ff;\n  border-color: #0a78ff;\n  color: #fff;\n}\n#wrap.page-market.download .download-item__btn:focus-visible {\n  outline: 2px solid #0a78ff;\n  outline-offset: 2px;\n}\n\n#wrap.page-market.download .download-empty {\n  padding: 120px 0;\n  text-align: center;\n  font-size: 16px;\n  color: #9aa3b2;\n}\n\n/* 페이징 1 / N */\n#wrap.page-market.download .download-paging {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 40px;\n  margin-top: 48px;\n}\n#wrap.page-market.download .download-paging .num {\n  min-width: 40px;\n  text-align: center;\n  font-size: 14px;\n  color: #2a2c2f;\n}\n#wrap.page-market.download .download-paging button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: none;\n  border: 0;\n  color: #2a2c2f;\n  cursor: pointer;\n}\n#wrap.page-market.download .download-paging button:disabled {\n  color: #c5cbd5;\n  cursor: default;\n}\n\n/* 태블릿 */\n@media screen and (max-width: 1278px) {\n  #wrap.page-market.download .download-page {\n    padding: 100px 20px 120px;\n  }\n}\n\n/* 모바일 */\n@media screen and (max-width: 732px) {\n  #wrap.page-market.download .download-page {\n    padding: 48px 0 100px;\n  }\n  #wrap.page-market.download .download-page__title {\n    padding: 0 20px;\n    font-size: 32px;\n    text-align: left;\n  }\n  #wrap.page-market.download .download-page__body {\n    margin-top: 40px;\n  }\n  #wrap.page-market.download .download-tab li a {\n    padding: 0 20px;\n    height: 48px;\n    line-height: 46px;\n    font-size: 16px;\n  }\n  #wrap.page-market.download .download-list {\n    margin: 32px 16px 0;\n  }\n  #wrap.page-market.download .download-item {\n    flex-wrap: wrap;\n    align-items: flex-start;\n    padding: 20px 16px 16px 22px;\n  }\n  #wrap.page-market.download .download-item__no {\n    width: 34px;\n    font-size: 15px;\n    line-height: 24px;\n  }\n  #wrap.page-market.download .download-item__title {\n    flex-basis: calc(100% - 34px);\n    font-size: 15px;\n    line-height: 24px;\n  }\n  #wrap.page-market.download .download-item__btn {\n    margin: 16px 0 0 auto;\n  }\n  #wrap.page-market.download .download-paging {\n    margin-top: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
